import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "BreadCrumbComponentstyle__Container",
  componentId: "sc-1rnat27-0"
})(["", " @media (max-width:", "){", ";}@media (max-width:", "){", ";}"], {
  "display": "flex",
  "flexDirection": "row",
  "flexWrap": "nowrap",
  "alignItems": "center",
  "gap": "1rem",
  "overflow": "hidden",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingRight": "1rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "paddingLeft": "1rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "overflowX": "scroll"
});
export const BreadItem = styled.div.withConfig({
  displayName: "BreadCrumbComponentstyle__BreadItem",
  componentId: "sc-1rnat27-1"
})(["", " color:", ";svg{opacity:", ";}a{", " &:hover{", "}}b{", "}"], {
  "zIndex": "20",
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem",
  "whiteSpace": "nowrap",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "300"
}, ({
  $Color
}) => $Color, ({
  $Color
}) => $Color === '#ffffff' ? '0.5' : '1', {
  "zIndex": "20",
  "cursor": "pointer",
  "opacity": "0.5",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(241 157 99 / var(--tw-text-opacity, 1))",
  "opacity": "1",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "opacity": "1"
});